import { GetSummaryResponseDTO } from '@/api/attestation/DTOs';
import { AttestationSummary } from '@/typings';
import { adaptDecimalValueToPercentage } from '../utilities';
import { adaptGetSummaryResponseToAttestationSummary } from './getSummaryResponseToAttestationSummary.adapter';

export const adaptGetAttestationSummaryResponseToApplicationSummary = (
  attestationSummaryResponse: GetSummaryResponseDTO,
): {
  completedPercentage: number;
  completedSections: number;
  attestationSummary: AttestationSummary;
} => {
  return {
    completedPercentage: adaptDecimalValueToPercentage(
      attestationSummaryResponse.application.applicationCompletedPercentage,
    ),
    completedSections:
      attestationSummaryResponse.application.applicationSectionsCompleted,
    attestationSummary: adaptGetSummaryResponseToAttestationSummary(
      attestationSummaryResponse.attestation,
    ),
  };
};
